export default "__VITE_ASSET__GC8OeHZ9__"